export default "__VITE_ASSET__CODK_xMB__"